export default __webpack_public_path__ + "static/assets/26a6bbad092243ce2e2bb11e3165b3c0.svg";